export default {"src":"/_next/static/media/eye-slash-fill.85b73faf.svg","height":8,"width":8,"blurWidth":0,"blurHeight":0};